var EmailFormTextInputView, EmailFormTextLineInputView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require('./text_input_view');

EmailFormTextLineInputView = (function(superClass) {
  extend(EmailFormTextLineInputView, superClass);

  function EmailFormTextLineInputView() {
    return EmailFormTextLineInputView.__super__.constructor.apply(this, arguments);
  }

  EmailFormTextLineInputView.prototype.tagName = 'li';

  EmailFormTextLineInputView.prototype.events = {
    'keyup .text_line_input': 'validateEmailForm'
  };

  EmailFormTextLineInputView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = ".text_line_input";
    return this.template = {
      text_line_input_template: true
    };
  };

  return EmailFormTextLineInputView;

})(EmailFormTextInputView);

module.exports = EmailFormTextLineInputView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9jb21tb24vdmlld3MvdGV4dF9saW5lX2lucHV0X3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvc3VwcG9ydC9mcm9udGVuZC92aWV3cy9jb21tb24vdmlld3MvdGV4dF9saW5lX2lucHV0X3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsa0RBQUE7RUFBQTs7O0FBQUEsc0JBQUEsR0FBeUIsT0FBQSxDQUFRLG1CQUFSOztBQUVuQjs7Ozs7Ozt1Q0FDSixPQUFBLEdBQVM7O3VDQUVULE1BQUEsR0FDRTtJQUFBLHdCQUFBLEVBQTBCLG1CQUExQjs7O3VDQUVGLFVBQUEsR0FBWSxTQUFBO0lBQ1Ysc0JBQXNCLENBQUEsU0FBRSxDQUFBLFVBQVUsQ0FBQyxLQUFuQyxDQUF5QyxJQUF6QyxFQUErQyxTQUEvQztJQUNBLElBQUMsQ0FBQSxTQUFELEdBQWE7V0FDYixJQUFDLENBQUEsUUFBRCxHQUFZO01BQUMsd0JBQUEsRUFBMEIsSUFBM0I7O0VBSEY7Ozs7R0FOMkI7O0FBV3pDLE1BQU0sQ0FBQyxPQUFQLEdBQWlCIn0=
